import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.99 13a3 3 0 0 0-3-3h-1.3a3 3 0 0 0-2.968 2.565Q7.985 17.6 7.98 24.07q-.005 6.445.718 11.366A3 3 0 0 0 11.667 38h1.323a3 3 0 0 0 3-3zM9.981 24.071q.004-6.333.72-11.216a1 1 0 0 1 .99-.855h1.299a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-1.323a1 1 0 0 1-.989-.855q-.701-4.766-.697-11.074m24.15-12.996a3 3 0 0 1 3.316 2.647q.549 4.903.553 10.342.003 5.409-.532 10.212a3 3 0 0 1-4.57 2.213l-15.252-9.52a3.5 3.5 0 0 1-.002-5.936l15.232-9.52a3 3 0 0 1 1.256-.438m-15.904 13.72a1.5 1.5 0 0 1 .477-2.066l15.232-9.52a1 1 0 0 1 1.524.736q.536 4.79.54 10.12.003 5.3-.52 9.99a1 1 0 0 1-1.523.737l-15.252-9.519a1.5 1.5 0 0 1-.478-.477",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Skip-Previous-Outlined_svg__a",
      width: 31,
      height: 28,
      x: 7,
      y: 10,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M15.99 13a3 3 0 0 0-3-3h-1.3a3 3 0 0 0-2.968 2.565Q7.985 17.6 7.98 24.07q-.005 6.445.718 11.366A3 3 0 0 0 11.667 38h1.323a3 3 0 0 0 3-3zM9.981 24.071q.004-6.333.72-11.216a1 1 0 0 1 .99-.855h1.299a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-1.323a1 1 0 0 1-.989-.855q-.701-4.766-.697-11.074m24.15-12.996a3 3 0 0 1 3.316 2.647q.549 4.903.553 10.342.003 5.409-.532 10.212a3 3 0 0 1-4.57 2.213l-15.252-9.52a3.5 3.5 0 0 1-.002-5.936l15.232-9.52a3 3 0 0 1 1.256-.438m-15.904 13.72a1.5 1.5 0 0 1 .477-2.066l15.232-9.52a1 1 0 0 1 1.524.736q.536 4.79.54 10.12.003 5.3-.52 9.99a1 1 0 0 1-1.523.737l-15.252-9.519a1.5 1.5 0 0 1-.478-.477",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Skip-Previous-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgSkipPreviousOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SkipPreviousOutlined_default = SvgSkipPreviousOutlined;

export { SkipPreviousOutlined_default as default };
